import { getUnitsByFeatures } from './units';

/**
 * SaveDataManager - Hanterar Web Worker för att bearbeta och förbereda data för att spara districts
 */
class SaveDataManager {
    constructor() {
        this.workerInstance = null;
    }

    /**
     * Skapa areas för att spara
     * @param {Array} selectedAreas - Array av GeoJSON features
     * @param {Object} turfPolygons - Object med turf polygons per type
     * @param {Array} units - Array av units
     * @param {Function} onSave - Callback när save-data är klar: (saveData) => void
     * @param {Function} onLoading - Callback för loading progress: (percentage) => void
     * @param {Function} onReset - Callback för att resetta state: () => void
     */
    createAreasForSave(selectedAreas, turfPolygons, units, onSave, onLoading, onReset) {
        // Terminera tidigare worker om den finns
        if (this.workerInstance) {
            this.workerInstance.terminate();
            this.workerInstance = null;
            if (onReset) {
                onReset();
            }
        }
        
        // Skapa ny worker
        this.workerInstance = new Worker(new URL('./worker.js', import.meta.url));

        // Hantera meddelanden från worker
        this.workerInstance.onmessage = (message) => {
            const { type, ...rest } = message.data;
            
            if (type === 'save') {
                // Beräkna units i områdena
                const filteredUnitsInArea = getUnitsByFeatures(selectedAreas, units);

                // Skapa save-data med units
                const saveData = {
                    ...rest,
                    units: filteredUnitsInArea.map(m => m.companyId)
                };

                // Anropa callback
                if (onSave) {
                    onSave(saveData);
                }

                // Terminera worker efter save
                this.terminate();
            }      
            
            if (type === 'loading') {
                // Anropa loading callback
                if (onLoading) {
                    onLoading(rest.percentage);
                }
            }
        };
        
        // Skicka data till worker
        this.workerInstance.postMessage({ 
            selectedAreas, 
            turfPolygons
        });
    }

    /**
     * Terminera worker-instansen
     */
    terminate() {
        if (this.workerInstance) {
            this.workerInstance.terminate();
            this.workerInstance = null;
        }
    }

    /**
     * Kolla om worker är aktiv
     */
    isActive() {
        return this.workerInstance !== null;
    }
}

const saveDataManagerInstance = new SaveDataManager();
export default saveDataManagerInstance;

